export default __webpack_public_path__ + "static/media/spartan.209aab40.svg";